import * as React from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { labelGreyColour, labelRedColour, tabletPortraitMinWidth, whiteColour } from '../../cssConstants';
import { LinkButton } from './LinkButton';

const FormButtons = ({
	onOtherButtonClick,
	onContinueButtonClick,
	otherButtonText,
	continueButtonText,
	disabled = false,
	buttonPaddingTop = '20px',
	formButtonRef,
	mailTo,
	inModal = false,
	className,
	isWarning = false
}: Props) => {
	return (
		<StyledFormButtons $buttonPaddingTop={buttonPaddingTop} ref={formButtonRef} $inModal={inModal}>
			{onOtherButtonClick && (
				<StyledCustomButton type="button" variant="contained" onClick={onOtherButtonClick}>
					{otherButtonText}
				</StyledCustomButton>
			)}
			{mailTo ? (
				<LinkButton href={mailTo}>Contact Private Wealth</LinkButton>
			) : (
				<StyledCustomButton
					type="submit"
					variant="contained"
					onClick={onContinueButtonClick}
					disabled={disabled}
					className={className}
					$isSubmitButton
					$inModal={inModal}
					$isWarning={isWarning}
					$isDisabled={disabled}
				>
					{continueButtonText ?? 'Continue'}
				</StyledCustomButton>
			)}
		</StyledFormButtons>
	);
};

export default FormButtons;

interface Props {
	onOtherButtonClick?: () => void;
	onContinueButtonClick?: () => void;
	otherButtonText?: string;
	continueButtonText?: string;
	disabled?: boolean;
	buttonPaddingTop?: string;
	formButtonRef?: React.Ref<HTMLElement>;
	mailTo?: string;
	inModal?: boolean;
	className?: string;
	isWarning?: boolean;
}

const getButtonBackground = (
	isSubmitButton: boolean,
	isWarning: boolean,
	primaryBackground: string,
	isDisabled?: boolean
) => {
	if (!isSubmitButton) return '#F9FAFB';
	if (isDisabled) return `${labelGreyColour}`;

	return isWarning ? labelRedColour : primaryBackground;
};

const StyledFormButtons = styled.section<{ $buttonPaddingTop: string; $inModal: boolean }>`
	display: flex;
	flex-direction: column-reverse;
	justify-content: center;
	align-items: ${({ $inModal }) => ($inModal ? 'flex-start' : 'center')};
	margin-top: ${(props) => props.$buttonPaddingTop};
	text-align: center;
`;

const StyledCustomButton = styled(Button)<{
	$isSubmitButton: boolean;
	$inModal: boolean;
	$isWarning: boolean;
	$isDisabled?: boolean;
}>`
	font-size: 14px;
	font-weight: 400 !important;
	display: inline-flex;
	border-radius: 30px;
	text-transform: none;
	margin: ${({ $inModal }) => ($inModal ? '0' : '10px')};
	line-height: 22px;
	background: ${({ $isSubmitButton, $isWarning, theme, $isDisabled }) =>
		getButtonBackground($isSubmitButton, $isWarning, theme.primaryBackground, $isDisabled)};
	color: ${({ $isSubmitButton, theme }) => ($isSubmitButton ? whiteColour : theme.outlineColor)};
	height: 45px;
	min-width: ${({ $inModal }) => ($inModal ? '115px' : '237px')};
	padding: 0 30px;
	border: ${({ $isSubmitButton, theme }) => ($isSubmitButton ? 'none' : `1px solid ${theme.outlineColor}`)};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		height: 50px;
		min-width: 280px;
	}
`;
